import {DatePipe} from '@angular/common';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter} from '@angular/material/core';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthModule} from './auth/auth.module';
import {CoreModule} from './core/core.module';
import {AppInitService} from './services/app-init.service';
import {CustomDateAdapter} from './services/custom-date-adapter.service';
import {SharedModule} from './shared/shared.module';
import {IonicModule} from '@ionic/angular';

export function initializeApp(appInitService: AppInitService) {
  // eslint-disable-next-line
  return (): Promise<any> => {
    return appInitService.initApp(window.location.pathname);
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AuthModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    MatDialogModule,
    IonicModule.forRoot({}),
  ],
  providers: [
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
    {
      provide: MatDialogRef,
      useValue: {},
    },
    provideCharts(withDefaultRegisterables()),
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true},
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
